import { Delete } from "@airhelp/icons";
import {
  Accordion,
  AccordionItem,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  IconButton,
  VStack,
} from "@chakra-ui/react";
import { useReturningUsersNotification } from "hooks";
import { useMobileMenuStore } from "stores/MobileMenuStore";
import { HamburgerMenuIcon } from "styles/icons";
import { ActionButton } from "../../HeaderButtons/ActionButton";
import { isHeaderLinkGroup } from "../../Header.utils";
import { HeaderLink } from "../../HeaderLink";
import type { HeaderLink as HeaderLinkType, HeaderProps } from "../../types";
import { HeaderLinkGroup } from "./HeaderLinkGroup";
import { useCloseOnNavigation } from "../../Header.hooks";

const renderHeaderLinks = (headerLink: HeaderLinkType) =>
  isHeaderLinkGroup(headerLink) ? (
    <HeaderLinkGroup
      key={headerLink._uid}
      headerLinksGroupItems={headerLink.headerLinksGroupItems}
      headerLinksGroupMainGroupLinkName={headerLink.headerLinksGroupMainGroupLinkName}
    />
  ) : (
    <AccordionItem key={headerLink._uid} border="none" bg="transparent" fontSize="lg">
      <HeaderLink {...headerLink} />
    </AccordionItem>
  );

export const HeaderLinks = ({
  headerLinks,
  headerActionButton,
}: Pick<HeaderProps, "headerActionButton" | "headerLinks">) => {
  const { isOpen: isMobileMenuOpen, close: closeMobileMenu, openMobileMenu } = useMobileMenuStore();
  const { isOpen: isNotificationVisible } = useReturningUsersNotification();
  useCloseOnNavigation(closeMobileMenu);

  return (
    <>
      <IconButton
        h={8}
        minH="initial"
        icon={isMobileMenuOpen ? <Delete color="primary.900" h={4} /> : <HamburgerMenuIcon color="primary.900" h={4} />}
        p={0}
        variant="unstyled"
        minWidth={6}
        _hover={{}}
        _active={{}}
        onClick={() => (isMobileMenuOpen ? closeMobileMenu() : openMobileMenu())}
        data-testid="mobile-menu-button"
        aria-label="Open menu"
        justifyContent="flex-end"
      />
      <Drawer isOpen={isMobileMenuOpen} placement="right" onClose={closeMobileMenu} size={{ base: "full", md: "sm" }}>
        <DrawerOverlay />
        <DrawerContent
          mt={isNotificationVisible ? 0 : "64px"}
          backgroundColor="white"
          maxH={`calc(100% - ${isNotificationVisible ? 0 : "64px"})`}
          borderTop="1px solid"
          borderColor="greyscale.400"
        >
          {isNotificationVisible && (
            <DrawerHeader minH={16} borderBottom="1px solid" borderColor="greyscale.400">
              <DrawerCloseButton size="lg" px={0} />
            </DrawerHeader>
          )}
          <DrawerBody>
            <Accordion allowToggle defaultIndex={0}>
              <VStack align="left" spacing={5} py={4}>
                {headerLinks.map(renderHeaderLinks)}
              </VStack>
            </Accordion>
          </DrawerBody>
          {headerActionButton && (
            <DrawerFooter borderTop="1px solid" borderColor="greyscale.400" px={4}>
              <ActionButton activeButtonOption={headerActionButton} />
            </DrawerFooter>
          )}
        </DrawerContent>
      </Drawer>
    </>
  );
};
